// When a notification tap last asked the app to navigate somewhere.
//
// RedirectToHome sends the app back to /home after it has been in the background
// for a few minutes. Tapping a notification also brings the app back from the
// background, and without this the redirect could land on top of the page the
// notification was meant to open (e.g. the FREE journey at the next video pill).

const RECENT_MS = 15000;

let lastPushNavigationAt = 0;

export const markPushNavigation = (now = Date.now()) => {
  lastPushNavigationAt = now;
};

export const hadRecentPushNavigation = (now = Date.now(), withinMs = RECENT_MS) =>
  lastPushNavigationAt > 0 && now - lastPushNavigationAt <= withinMs;

// Tests only.
export const resetPushNavigationClock = () => {
  lastPushNavigationAt = 0;
};
